import React from 'react';
import PropTypes from 'prop-types';
import NewsByCategoryBlockItem from './NewsByCategoryBlockItem';
import Link from 'components/Link';
import NoContent from 'components/NoContent';
import './NewsByCategoryBlock.scss';

const NewsByCategoryBlock = ({
  heading,
  items,
  seeAllLink,
  lang = {
    publishedLabel: 'Publisert',
    noContentMessage: 'Ingen nyheter funnet for de valgte kategoriene.',
  },
}) => {
  return items && items.length > 0 ? (
    <div className="news-by-category-block">
      <div className="news-by-category-block__container">
        {heading && (
          <h2 className="news-by-category-block__heading">{heading}</h2>
        )}
        <ul className="news-by-category-block__list">
          {items.map((item, index) => (
            <li className="news-by-category-block__item" key={index}>
              <NewsByCategoryBlockItem
                {...item}
                publishedLabel={lang.publishedLabel}
                headingTagLevel={heading ? 3 : 2}
              />
            </li>
          ))}
        </ul>
        {seeAllLink && (
          <div className="news-by-category-block__see-all-link-holder">
            <Link {...seeAllLink} />
          </div>
        )}
      </div>
    </div>
  ) : (
    <NoContent
      heading={heading}
      message={lang.noContentMessage}
      link={seeAllLink}
      className="news-by-category-block__no-content"
    />
  );
};

NewsByCategoryBlock.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.exact(NewsByCategoryBlockItem.propTypes))
    .isRequired,
  seeAllLink: PropTypes.exact(Link.propTypes),
  lang: PropTypes.shape({
    publishedLabel: PropTypes.string.isRequired,
    noContentMessage: PropTypes.string.isRequired,
  }).isRequired,
};

export default NewsByCategoryBlock;
